export default function Projects(){
	return(
		<div className="container">
			<h2>PROJECTS</h2>
			<div className="projectsDiv">
			<div className="project">
					<img className="projectImg" src="https://cdn.pixabay.com/photo/2016/07/23/13/21/pokemon-1536855_960_720.png" alt="PokeDex"></img>
					<h3 className="link">PokeDex</h3>
				</div>
				<div className="project">
					<img className="projectImg" src="https://static.vecteezy.com/system/resources/thumbnails/010/570/505/small/casino-game-card-deck-glyph-pictogram-play-card-black-icon-gambling-addiction-risk-in-vegas-sign-playing-bridge-black-jack-royal-poker-flat-symbol-isolated-illustration-vector.jpg" alt="Card Games"></img>
					<h3 className="link">Card Games</h3>
				</div>
				<div className="project">
					<img className="projectImg" src="https://upload.wikimedia.org/wikipedia/commons/thumb/6/6f/Eo_circle_light-green_checkmark.svg/2048px-Eo_circle_light-green_checkmark.svg.png" alt="To-Do List"></img>
					<h3 className="link">To-Do List</h3>
				</div>
			</div>

		</div>
	)
}